import { render, staticRenderFns } from "./EditHospitalForm.vue?vue&type=template&id=d28eda2a&"
import script from "./EditHospitalForm.vue?vue&type=script&lang=js&"
export * from "./EditHospitalForm.vue?vue&type=script&lang=js&"
import style0 from "./EditHospitalForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports